import { MentionedType } from '@/shared/types/post/enums/MentionedType'

import { axios, Response } from '../index'

type ResponseBody = {
  postId: number
  content: string
  userId: number
  companyId: number
  postCommentId: number
}
type Mention = { mentionedType: MentionedType; taggedPersonsIds: string[] }

export default async function createPostCommentFeed(body: {
  postId: number
  content: string
  mentions: Mention[]
}): Response<ResponseBody> {
  return await axios.post('/v6/comments', body)
}
